import React, { useState } from "react";
import styled from "styled-components";
import DesignDrawer from "./DesignDrawer";
import PreviewImage from "./PreviewImage";

const PreviewContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 300px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-family: Helvetica;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
`;

const EditButton = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  font-weight: normal;
  color: #4c8cee;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const CardPreview = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleClose = () => {
    setDrawerOpen(false);
  };

  return (
    <>
      <PreviewContainer>
        <PreviewImage refreshKey={refreshKey} />
        <ContentWrapper>
          <Title>Card Preview</Title>
          <EditButton onClick={() => setDrawerOpen(true)}>edit design</EditButton>
        </ContentWrapper>
      </PreviewContainer>

      <DesignDrawer open={drawerOpen} onClose={handleClose} onSaved={handleSaved} />
    </>
  );
};

export default CardPreview;
